import React from 'react'
import {Helmet} from "react-helmet"
import { connect } from 'react-redux'
import { fetchReviewIfNeeded } from '~/reviews/actions'

import subjects from '~/comm'
import ImageSlider from '~/core/components/ImageSlider'

class Review  extends React.Component {

  constructor() {
    super();
    this.state = {
      data: []
    }
  }

  static fetchData(store, route, match) {
    return Promise.all([
      store.dispatch(fetchReviewIfNeeded(match.params.type, match.params.id))
    ])
  }

  componentDidMount() {
    const { match, history, dispatch } = this.props
    dispatch(fetchReviewIfNeeded(match.params.type, match.params.id))
  }

  render() {
    const { match, history, reviews } = this.props
    const data = this.state.data;
    var article = []
    console.log(match.params)
    let cover = null

    var review, type
    if ( reviews.reviews.active && reviews.reviews[reviews.reviews.active] && !reviews.reviews[reviews.reviews.active].isFetching ) {
      review = reviews.reviews[reviews.reviews.active]
      type = reviews.reviews[reviews.reviews.active].type.map((item) => ( item.target_id.replace('review_', '') ))[0]
    }

    function bla(str) { return str.replace(/^\((.*)\)$/g, '$1') }

    if (review && review.title) {
      var worsemarkup = '<p>' + review.body[0].value.replace(/\n\s*\n/g, '</p>\n\n<p>') + '</p>'
      var badmarkup = { __html: worsemarkup }
       article.push(
         <div>
          <div className="art">
            { (review['field_review_'+ type +'_image'] && review['field_review_'+ type +'_image'].length > 1) ?
                <ImageSlider style={{height: '600px'}} data={review['field_review_'+ type +'_image']} />
              : <img src={review['field_review_'+ type +'_image'][0].url } />
             }
          </div>
          <div className="review">
            <Helmet>
              <title>{review.title[0].value}</title>
              <meta name="description" content={review['field_review_'+ type +'_teaser'][0].value.replace(/<[^>]+>/g, '') } />
              <meta name="og:description" content={review['field_review_'+ type +'_teaser'][0].value.replace(/<[^>]+>/g, '') } />
              <meta property="og:title" content={review.title[0].value} />
              <meta property="og:image" content={review['field_review_'+ type +'_image'][0].url } />
              <meta property="og:type" content="article" />
            </Helmet>
            <h2>{review.title[0].value}</h2>
            <div dangerouslySetInnerHTML={badmarkup} />
          </div>
        </div>
       )
    } else {
      article.push(match.params.id)
    }

    if (!article) {
      return null
    }
    const back = (e) => {
      e.stopPropagation()
      history.goBack()
      subjects.closeModal.next('close')
    }
    return (
      <div onClick={back} className='modal-bg'>
        <Helmet>
          <title>Off Air: Reviews</title>
          <meta name="description" content="4ZZZ Community Radio Brisbane" />
        </Helmet>
        <div className='review modal'>
          {article}
          <button type='button' onClick={back}>
            Close
          </button>
        </div>
      </div>
    )
  }
}

export default connect(state => { return { reviews: state.reviews } }) (Review)
